const StopChatIcon = ({ className = '', ...props }) => (
    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
        <path
            d="M0 13.5C0 6.075 6.04607 0 13.5 0C20.9539 0 27 6.075 27 13.5C27 20.925 20.9539 27 13.5 27C6.04607 27 0 20.925 0 13.5Z"
            fill="black"
        />
        <path
            d="M9 10.125C9 9.45 9.50625 9 10.125 9H16.875C17.4937 9 18 9.45 18 10.125V16.875C18 17.55 17.4937 18 16.875 18H10.125C9.50625 18 9 17.55 9 16.875V10.125Z"
            fill="white"
        />
    </svg>
);

export default StopChatIcon;
